import { makeAutoObservable } from 'mobx';
import Rule, { RuleDto } from './Rule';

export default class Rules {
  items: Rule[] = [];
  selected?: Rule = undefined;

  constructor(
    dto: RuleDto[] = [],
    private readonly onSave?: (list: Rules) => Promise<void>,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });
    this.items = dto.map((ruleDto) => new Rule(ruleDto, this.saveRule));
  }

  get isEmpty() {
    return this.items.length === 0;
  }

  createRule(defaultValues: Partial<RuleDto> = {}): Rule {
    const rule = new Rule(
      {
        destinationPath: '{Documents}/Native Instruments/User Content/Kontakt',
        ...defaultValues,
      },
      this.saveRule,
    );
    this.selectRule(rule);
    return rule;
  }

  async moveDown(ruleIndex: number) {
    moveArrayItem(this.items, ruleIndex, ruleIndex + 1);
    await this.onSave?.(this);
  }

  async moveUp(ruleIndex: number) {
    moveArrayItem(this.items, ruleIndex, ruleIndex - 1);
    await this.onSave?.(this);
  }

  selectRule(rule?: Rule) {
    this.selected = rule;
  }

  toJSON() {
    return this.items.map((item) => item.toJSON());
  }

  private async saveRule(rule: Rule) {
    if (rule.isDeleted) {
      this.items = this.items.filter((r) => r !== rule);
    } else if (!this.items.includes(rule)) {
      this.items.push(rule);
    }

    await this.onSave?.(this);
  }
}

function moveArrayItem(array: any[], fromIndex: number, toIndex: number) {
  if (toIndex >= array.length) {
    let k = toIndex - array.length + 1;
    // eslint-disable-next-line no-plusplus
    while (k--) {
      array.push(undefined);
    }
  }
  array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
  return array;
}
